import { ShipmentRequest } from "./ShipmentRequest";

export class ShipmentRequestJson {
    ShipmentRequest: ShipmentRequest ; 
}
 